
























import { BButton, BCard, BSpinner, BContainer, VBTooltip } from "bootstrap-vue";
import { TemplateInterface } from "@/interfaces/template.interface";
import { computed, defineComponent, PropType } from "@vue/composition-api";

export default defineComponent({
    components: { BButton, BCard, BSpinner, BContainer },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        disabled: {
            required: false,
            type: Boolean,
        },
        submittable: {
            required: false,
            type: Boolean,
        },
        createForm: {
            required: false,
            type: Boolean,
        },
        isLoading: {
            required: false,
            type: Boolean,
        },
        template: {
            required: true,
            type: Object as PropType<TemplateInterface>,
        },
    },
    setup(props) {
        const isUpdating = computed(() => {
            return props.template.id;
        });

        return {
            isUpdating,
        };
    },
});
